import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import moment from 'moment';
import * as XLSX from 'xlsx'
import ExportButtons from '../ExportButtons';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const CashFlowReport = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');
    let currentBalance = 0;

    useEffect(() => {
        const fetchData = async () => {
            const response = await Fetch.post(config.endpoints.backend + 'portal/getreport', props.filters);
            currentBalance = 0;
            setItems(response);
        }

        fetchData();
    }, [props.filters])

    function dataForSheet(){
        let sheets = {};

        const cashFlowTable = document.getElementById('cashFlow');
        const cashFlowData = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(cashFlowTable, {raw: true})), {raw: true, header: 1});
        
        const summaryCashFlowTable = document.getElementById('summaryCashFlow');
        const summaryCashFlowData = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(summaryCashFlowTable, {raw: true})), {raw: true, header: 1});

        sheets.cashFlowData = cashFlowData;
        sheets.summaryCashFlowData = summaryCashFlowData;
        
        return sheets;
    }

    function dataForCsv() {
        const tableCashFlow = document.getElementById('cashFlow');
    
        const dataTableCashFlow = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableCashFlow, {raw: true}), { header: 1, raw: true});
        
        let combinedData = [];
        combinedData = combinedData.concat(dataTableCashFlow);
        combinedData.push([]);

        const tableSummaryCashFlow = document.getElementById('summaryCashFlow');    
        const dataTableSummaryCashFlow = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableSummaryCashFlow, {raw: true}), { header: 1, raw: true});
        combinedData = combinedData.concat(dataTableSummaryCashFlow);

        return combinedData;
    }
    
    function dataForJson(){
        let cashFlow = [];
        let summaryCashFlow = {};
        let headers = Object.keys(items.reports.data.cashFlowReports[0]); 
        let currentBalanceJson = 0;
        items.reports.data.cashFlowReports.forEach(item => {
            let currentObject = {};

            for (const key of headers) {
                if(key !== 'pdc_accounting_project_id')
                    currentObject[key] = !!item[key] ? item[key] : '';
            }

            currentBalanceJson += (item['credit'] - item['debit']);
            currentObject['balance'] = currentBalanceJson.toFixed(2);
            cashFlow.push(currentObject)
        })

        for (const key in items.reports.data.summaryReport) {
            summaryCashFlow[key] = items.reports.data.summaryReport[key].value
        }

        return {
            cashFlow,
            summaryCashFlow
        };
    }

    return (
        <div>
        {items.reports && (
                <div>
                    <div className='containerCashFlow'>   
                        <div className='row info-filters'>
                            <div className='col-12'>
                                <p>Projeto: <b>{items.reports.pdcProject.project_name}</b></p>
                            </div>
                            <div className='col-12'>
                                <p>Origem dos Recursos: <b>{items.reports.originResourceName}</b></p>
                            </div>
                            <div className='col-12'>
                                <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <ExportButtons jsonData={dataForJson} csvData={dataForCsv} sheetData={dataForSheet} pdfAttributes={{
                                ids: ['cashFlow', 'summaryCashFlow'], 
                                optionsPdf: {
                                    format: 'a4', 
                                    orientation: 'landscape',
                                },
                                styles: {
                                    cashFlow: {
                                        columnStyles: {
                                            0: { cellWidth: 25 },
                                            1: { cellWidth: 30 },
                                            2: { cellWidth: 30 },
                                            3: { cellWidth: 20 },
                                            4: { cellWidth: 30 },
                                            5: { cellWidth: 40 },
                                            6: { cellWidth: 35 },
                                            7: { cellWidth: 32 },
                                            8: { cellWidth: 35 }
                                        }
                                    }
                                }
                            }}
                            txtAttributes={{
                                cashFlow: {
                                    colSizes: [15,50,140,80,80,50,50,50,50]
                                },
                                summaryCashFlow: {
                                    colSizes: [80]
                                }
                            }}
                            />
                        </div>
                        <div class="row">
                            <table className="table tables-report" id='cashFlow' margin="2" cellspacing="0" cellpadding="5">
                                <thead className='text-center '>
                                    <tr>
                                        <th style={{maxWidth: '200px'}} className=''>DATA</th>
                                        <th style={{maxWidth: '200px'}} className=''>Nº NFe</th>
                                        <th style={{maxWidth: '200px'}} className=''>FAVORECIDO</th>
                                        <th style={{maxWidth: '200px'}} className=''>DISCRIMINAÇÃO</th>
                                        <th style={{maxWidth: '200px'}} className=''>SUB-CATEGORIA</th>
                                        <th style={{maxWidth: '200px'}} className=''>Nº DOC.Pgto</th>
                                        <th style={{maxWidth: '200px'}} className=''>CRÉDITO</th>
                                        <th style={{maxWidth: '200px'}} className=''>DÉBITO</th>
                                        <th style={{maxWidth: '200px'}} className=''>SALDO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.reports.data.cashFlowReports.map((row, rowIndex) => {
                                        currentBalance += (parseFloat(row.credit) - parseFloat(row.debit))
                                        return <tr key={rowIndex}>
                                            <td className='tdValue'>{row.date_ref}</td>
                                            <td className='tdValue text-left'>{row.nfe}</td>
                                            <td className='tdValue text-left'>{row.people_name}</td>
                                            <td className='tdValue text-left'>{row.description}</td>
                                            <td className='tdValue text-left'>{row.sub_category}</td>
                                            <td className='tdValue text-center'>{row.document_number}</td>
                                            <td className='tdValue text-right' style={{color: 'blue', width: '15rem'}}>{row.credit == 0 ? '' : formatCurrency(row.credit)}</td>
                                            <td className='tdValue text-right' style={{color: 'red', width: '15rem'}}>{row.debit == 0 ? '' : formatCurrency(row.debit)}</td>
                                            <td className='tdValue text-right' style={{color: currentBalance < 0 ? 'red' : 'blue', width: '15rem'}}>{formatCurrency(currentBalance.toFixed(2))}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <table className="table tables-report small-table" id='summaryCashFlow' margin="2" cellspacing="0" cellpadding="5">
                                <thead className='text-center '>
                                    <tr>
                                        <th colSpan="2" style={{maxWidth: '200px'}} className=''>RESUMO TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr key='item-1'>
                                        <td className=''>{items.reports.data.summaryReport.previous_balance.label}</td>
                                        <td className='tdValue' style={{color: 'blue'}}>{formatCurrency(items.reports.data.summaryReport.previous_balance.value)}</td>
                                    </tr>
                                    <tr key='item-2'>
                                        <td className=''>{items.reports.data.summaryReport.total_credit.label}</td>
                                        <td className='tdValue' style={{color: 'blue'}}>{formatCurrency(items.reports.data.summaryReport.total_credit.value)}</td>
                                    </tr>
                                    <tr key='item-3'>
                                        <td className=''>{items.reports.data.summaryReport.total_debit.label}</td>
                                        <td className='tdValue' style={{color: 'red'}}>{formatCurrency(items.reports.data.summaryReport.total_debit.value)}</td>
                                    </tr>
                                    <tr key='item-4'>
                                        <td className=''>{items.reports.data.summaryReport.current_balance.label}</td>
                                        <td className='tdValue' style={{color: 'red'}}>{formatCurrency(items.reports.data.summaryReport.current_balance.value)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
    
export default CashFlowReport;
    